import type { ISocialOffer, ISocialOfferMetadata } from "@bbj-types/offer";
import type { ISocialApplyBody } from "../../services/apply/postSocialApplies";

type TSocialOfferPayload = ISocialApplyBody["socialOffer"];

export const formatSocialOfferForApi = (offer: ISocialOffer): TSocialOfferPayload => {
  return {
    name: offer.name,
    address: offer.address,
    offerId: offer.offerId,
    externalId: offer.externalId,
    source: offer.source,
    description: offer.description,
    url: offer.url,
    loc: offer.loc,
    beneficiaries: offer.beneficiaries,
    registrationModalities: offer.registrationModalities,
    contact: offer.contact,
    editor: offer.editor,
    creator: offer.creator,
    provider: offer.provider,
    metadata: formatMetadata(offer.metadata),
    organisation: offer.organisation,
    services: offer.services,
    tags: offer.tags,
    criteria: formatCriteria(offer.criteria),
    financingModes: offer.financingModes,
    documents: offer.documents,
    publicationDate: offer.publicationDate,
    publicationUpdatedDate: offer.publicationUpdatedDate,
    serviceStartDate: offer.serviceStartDate,
    serviceEndDate: offer.serviceEndDate,
    romeCodes: offer.romeCodes,
    perimeter: offer.perimeter?.map((place) => place._id),
    isRemote: offer.isRemote,
  };
};

const formatMetadata = (metadata: ISocialOffer["metadata"]): ISocialOfferMetadata | undefined => {
  if (!metadata) {
    return undefined;
  }

  const travel = metadata.travel ?? {};

  return {
    filtersHash: metadata.filtersHash,
    rank: metadata.rank,
    score: metadata.score,
    starredAt: metadata.starredAt,
    travel: {
      time: travel.time,
      type: travel.type,
      distance: travel.distance,
      infos: travel.infos?.map((info) => ({
        to: info.to,
        from: info.from,
        mode: info.mode,
        type: info.type,
        duration: info.duration,
        code: info.code,
        color: info.color,
        network: info.network,
      })),
    },
  };
};

const formatCriteria = (
  criteria: ISocialOffer["criteria"]
): { label?: string; key?: string; value?: string }[] | undefined => {
  if (!criteria) {
    return undefined;
  }

  return criteria.map((c) => ({
    label: c.label,
    key: c.key,
    value: c.value !== undefined ? String(c.value) : undefined,
  }));
};
